export const taskSectionStyles = {
  marginTop: '8px',
};
